import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { PriceVersion } from '@icc/b2b/shared';
import { PriceVersionService } from './price-version.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'icc-price-version-selector',
    templateUrl: './price-version-selector.component.html',
    styleUrls: ['./price-version-selector.component.scss']
})
export class PriceVersionSelectorComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];
    @Input() activatedPriceVersion: PriceVersion | null = null;
    @Output() priceVersionSelected = new EventEmitter<PriceVersion>();

    loaded$ = new BehaviorSubject(false);
    allPriceVersions$: Observable<PriceVersion[]> = this.priceVersionService.allPriceVersions$.pipe(
        map(data => data?.filter(item => item.hasAccess))
    );
    actualPriceVersion: PriceVersion;


    constructor(
        private priceVersionService: PriceVersionService
    ) {
        this.subscriptions.push(
            this.priceVersionService.actualPriceVersion$.subscribe(data => {
                this.actualPriceVersion = data;
            }),
        );
    }

    onPriceVersionSelected(version) {
        if (version) {
            this.activatedPriceVersion = this.priceVersionService.getPriceVersion(+version);
            this.priceVersionSelected.next(this.activatedPriceVersion);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.map(el => el.unsubscribe());
    }

    get invalidVersionEffectiveDate() {
        return this.activatedPriceVersion?.effectiveDate && (new Date() < new Date(this.activatedPriceVersion.effectiveDate));
    }

    get invalidVersionExpiredDate() {
        return this.activatedPriceVersion?.expiredDate && (new Date() > new Date(this.activatedPriceVersion.expiredDate));
    }
}
